import React from 'react';
import { Phone, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-white nothing"
    >
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
        <div className="absolute top-20 right-10 w-96 h-96 bg-sky-blue rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-80 h-80 bg-primary rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-8 animate-fade-in">
            <div className="inline-block">
              <span className="bg-sky-blue/10 text-primary px-4 py-2 rounded-full text-sm font-semibold">
                Professional HVAC Solutions
              </span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Complete Air Conditioning
              <span className="text-primary"> Solutions</span>
            </h1>

            <p className="text-2xl text-gray-600 font-medium">
              Sales • Installation • Repair • Maintenance
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Coolant Air Systems provides reliable and efficient air
              conditioning solutions for residential, commercial, and industrial
              clients.
            </p>

            {/* Key features */}
            <div className="grid sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-center gap-3">
                <CheckCircle2
                  className="text-primary flex-shrink-0"
                  size={24}
                />
                <span className="text-gray-700 font-medium">
                  Certified Technicians
                </span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle2
                  className="text-primary flex-shrink-0"
                  size={24}
                />
                <span className="text-gray-700 font-medium">24/7 Support</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle2
                  className="text-primary flex-shrink-0"
                  size={24}
                />
                <span className="text-gray-700 font-medium">
                  Affordable Pricing
                </span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle2
                  className="text-primary flex-shrink-0"
                  size={24}
                />
                <span className="text-gray-700 font-medium">Genuine Parts</span>
              </div>
            </div>

            {/* CTA buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-primary hover:bg-primary/90 text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
              >
                Get Free Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-6 text-lg transition-all"
              >
                <a href="tel:+919507331675">
                  <Phone className="mr-2" size={20} />
                  Call Now
                </a>
              </Button>
            </div>

            {/* Contact highlights */}
            <div className="flex flex-wrap gap-6 pt-6 border-t border-gray-200">
              <a
                href="tel:+919507331675"
                className="flex items-center gap-2 text-gray-700 hover:text-primary transition-colors"
              >
                <Phone size={20} className="text-primary" />
                <span className="font-semibold">+91 9507331675</span>
              </a>
              <a
                href="mailto:info@coolantairsystems.com"
                className="flex items-center gap-2 text-gray-700 hover:text-primary transition-colors"
              >
                <span className="font-semibold">
                  info@coolantairsystems.com
                </span>
              </a>
            </div>
          </div>

          {/* Right image */}
          <div className="relative lg:h-[600px] h-[400px] animate-fade-in-up">
            <div className="absolute inset-0 bg-gradient-to-br from-sky-blue/20 to-primary/20 rounded-3xl"></div>
            <img
              src="https://images.unsplash.com/photo-1762341123870-d706f257a12e"
              alt="Modern Air Conditioning Unit"
              className="relative w-full h-full object-cover rounded-3xl shadow-2xl"
            />
            {/* Floating card */}
            <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm p-6 rounded-2xl shadow-xl">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Trusted by</p>
                  <p className="text-3xl font-bold text-primary">2500+</p>
                  <p className="text-sm text-gray-700 font-medium">
                    Happy Clients
                  </p>
                </div>
                <div className="h-16 w-px bg-gray-300"></div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">Experience</p>
                  <p className="text-3xl font-bold text-primary">10+</p>
                  <p className="text-sm text-gray-700 font-medium">Years</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
